/* Kunstpflanzenmarkt: Galerie.
 *
 * Zwei Dinge: Thumbnail wechselt das Hauptbild, und Klick aufs Hauptbild
 * öffnet die Lightbox mit Zoom.
 *
 * Keine Slider-Bibliothek. Die PDP ist die Ads-Landingpage, und das
 * LCP-Ziel liegt bei unter 2,0 s mobil.
 */

(function () {
  'use strict';

  var gallery = document.querySelector('[data-kpm-gallery]');
  if (!gallery) return;

  var mainImg = gallery.querySelector('[data-kpm-main-img]');
  var thumbs = gallery.querySelectorAll('[data-kpm-thumb]');

  /* ---------- Thumbnail wechselt das Hauptbild ---------- */

  function select(thumb) {
    if (!mainImg) return;
    var full = thumb.dataset.full;
    if (!full) return;

    mainImg.src = full;
    mainImg.srcset = thumb.dataset.srcset || '';
    mainImg.alt = thumb.dataset.alt || '';

    thumbs.forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      select(thumb);
    });
  });

  /* ---------- Lightbox ---------- */

  var box = document.querySelector('[data-kpm-lightbox]');
  if (!box || !mainImg) return;

  var boxImg = box.querySelector('[data-kpm-lightbox-img]');
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    boxImg.src = mainImg.src;
    boxImg.srcset = mainImg.srcset;
    boxImg.alt = mainImg.alt;
    boxImg.classList.remove('is-zoomed');
    box.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
    box.querySelector('[data-kpm-lightbox-close]').focus();
  }

  function close() {
    box.removeAttribute('data-open');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  gallery.querySelector('[data-kpm-open-lightbox]').addEventListener('click', open);
  box.querySelector('[data-kpm-lightbox-close]').addEventListener('click', close);

  box.addEventListener('click', function (event) {
    // Klick auf den Grund schließt, Klick aufs Bild zoomt.
    if (event.target === box) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && box.hasAttribute('data-open')) close();
  });

  /* Zoom: Klick schaltet um, danach folgt der Ausschnitt dem Zeiger.
   * Auf Touch bleibt es beim Umschalten, dort übernimmt die
   * Pinch-Geste des Browsers. */
  boxImg.addEventListener('click', function () {
    boxImg.classList.toggle('is-zoomed');
  });

  boxImg.addEventListener('mousemove', function (event) {
    if (!boxImg.classList.contains('is-zoomed')) return;
    var rect = boxImg.getBoundingClientRect();
    var x = ((event.clientX - rect.left) / rect.width) * 100;
    var y = ((event.clientY - rect.top) / rect.height) * 100;
    boxImg.style.transformOrigin = x + '% ' + y + '%';
  });
})();
